import { render, staticRenderFns } from "./optimiserAutoAddPanelDialog.vue?vue&type=template&id=6a95bcae&scoped=true&"
import script from "./optimiserAutoAddPanelDialog.vue?vue&type=script&lang=js&"
export * from "./optimiserAutoAddPanelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95bcae",
  null
  
)

export default component.exports